function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }

function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }

function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }

function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }

function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }

function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }

function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }

function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }

function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }

function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }

import { Controller } from "@hotwired/stimulus";
import { formatDistanceToNow } from "date-fns";

var src_default = /*#__PURE__*/function (_Controller) {
  _inherits(src_default, _Controller);

  var _super = _createSuper(src_default);

  function src_default() {
    _classCallCheck(this, src_default);

    return _super.apply(this, arguments);
  }

  _createClass(src_default, [{
    key: "initialize",
    value: function initialize() {
      this.isValid = true;
    }
  }, {
    key: "connect",
    value: function connect() {
      this.load();

      if (this.hasRefreshIntervalValue && this.isValid) {
        this.startRefreshing();
      }
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      this.stopRefreshing();
    }
  }, {
    key: "load",
    value: function load() {
      var datetime = this.datetimeValue;
      var date = Date.parse(datetime);
      var options = {
        includeSeconds: this.hasIncludeSecondsValue,
        addSuffix: this.hasAddSuffixValue,
        locale: this.locale
      };

      if (Number.isNaN(date)) {
        this.isValid = false;
        console.error("[stimulus-timeago] Value given in 'data-timeago-datetime' is not a valid date (".concat(datetime, "). Please provide a ISO 8601 compatible datetime string. Displaying given value instead."));
      }

      this.element.dateTime = datetime;
      this.element.innerHTML = this.isValid ? formatDistanceToNow(date, options) : datetime;
    }
  }, {
    key: "startRefreshing",
    value: function startRefreshing() {
      var _this = this;

      this.refreshTimer = setInterval(function () {
        _this.load();
      }, this.refreshIntervalValue);
    }
  }, {
    key: "stopRefreshing",
    value: function stopRefreshing() {
      if (this.refreshTimer) {
        clearInterval(this.refreshTimer);
      }
    }
  }]);

  return src_default;
}(Controller);

src_default.values = {
  datetime: String,
  refreshInterval: Number,
  includeSeconds: Boolean,
  addSuffix: Boolean
};
export { src_default as default };